//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import { GOAL_ID_TO_GOAL_KEY, GOAL_ID_BY_TYPE } from '@/constants/goalIdByType'

export default {
  props: {
    /**
     * Area page: diet | sex-drive | stress | energy | sleep
     */
    area: {
      type: String,
      required: true
    },
    /**
     * Goal name for the new quiz
     */
    goalName: {
      type: String,
      default: null
    },
    /**
     * User's name
     */
    name: {
      type: String,
      default: null
    },
    /**
     * Whether to show the pay now button
     */
    showPayNowButton: {
      type: Boolean,
      required: true
    },
    /**
     * Plan selected for user
     */
    planSelected: {
      type: String,
      default: null
    },
    isPayUpfrontActiveAb: {
      type: Boolean,
      default: false
    },
    goalId: {
      type: Number,
      default: -1
    }
  },
  computed: {
    // TODO: It is ridiculous to have this here in a subcomponent when the parent passes this in.
    //  Cleanup needed
    ...mapState('product', ['improvementProgramPrice']),
    ...mapGetters({
      getImprovementPlanPlusProgramPrice: 'product/getImprovementPlanPlusProgramPrice',
      getPlanPrice: 'product/getPlanPrice',
      isFastTrackSelected: 'product/isFastTrackSelected'
    }),
    date () {
      return this.getDateFormatted(2, 7)
    },
    heroImage () {
      const keyGoal = GOAL_ID_TO_GOAL_KEY[this.goalId]

      if (!keyGoal) {
        return this.getStaticsObject('/quiz-results/generic_goal_hero.jpg')
      } else {
        return this.getStaticsObject(`/quiz-results/${keyGoal}_hero.jpg`)
      }
    },
    specifications () {
      return this.$t('quizResults.header.specifications')
    },
    title () {
      if (!this.name || this.name === '') {
        return this.$t('quizResults.header.titleDynamic.generic', { goal: this.goal, date: this.date })
      }
      if (GOAL_ID_BY_TYPE.TO_IMPROVE.includes(this.goalId)) {
        return this.$t('quizResults.header.titleDynamic.improve', { name: this.name ? `${this.capitalize(this.name)}` : 'Hey', goal: this.goal, date: this.date })
      } else if (GOAL_ID_BY_TYPE.TO_MANAGE.includes(this.goalId)) {
        return this.$t('quizResults.header.titleDynamic.manage', { name: this.name ? `${this.capitalize(this.name)}` : 'Hey', goal: this.goal, date: this.date })
      } else {
        return this.$t('quizResults.header.title', { name: this.name ? `${this.capitalize(this.name)}` : 'Hey', goal: this.goal, date: this.date })
      }
    },
    goal () {
      if (this.goalName) {
        const goalSplittedByAnd = this.goalName ? this.goalName.split('and') : ''
        if (goalSplittedByAnd.length > 1) {
          const goalBolded = goalSplittedByAnd.map(goal => '<b>' + this.capitalize(goal.replace(/\s/g, '')) + '</b>')
          const goalFormatted = goalBolded.join('+')
          return goalFormatted
        } else {
          return '<b>' + this.capitalize(this.goalName) + '</b>'
        }
      } else {
        return this.goalName
      }
    }
  },
  methods: {
    getDateFormatted (monthFromNow, daysFromNow = 0) {
      let date = new Date()
      date.setMonth(date.getMonth() + monthFromNow)
      date.setDate(date.getDate() + daysFromNow)
      date = date.toDateString().substring(4, 10)
      return `${date}`
    },
    emitTrackAddToCart () {
      this.$emit('trackAddToCart')
    },
    capitalize (text = '') {
      const arr = text.split(' ')
      return arr.map((el) => {
        return el.charAt(0).toUpperCase() + el.slice(1)
      }).join(' ')
    }
  }
}
